import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LibraryAddRoundedIcon from '@mui/icons-material/LibraryAddRounded';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import moment from "moment";
import Tooltip from '@mui/material/Tooltip';
import {logger} from '../utils';

export default function CopyDayDialog({ handleCopyCallback, data, taskFields}) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [day, setDay] = React.useState(moment())
    const [Hours, setHours] = React.useState(0);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');

    const separatorList = {
        period: {
            name: "period",
            regex: /^\d+(\.\d{0,2})?$/
        }
    };

    const initialValues = {
    };

    const validFormSchema = Yup.object({
    })

    const handleAlertClose = () => {
        setAlert(false);
    };

    const CheckBilled = async () => {

        const response = await fetch(`/api/Time_Entry/CheckBilled/${data.LabID}/${data.TaskID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return json;
            });
        return response;
    }

    const Check = async (list) => {
        let output = false;
        list.forEach((e, index) => {
            if (moment(day).isBetween(e.StartDate, e.EndDate)) {
                setAlertText("This time period has been locked. Check Entries or contact your Lead for assistance")
                setAlert(true)
                output = true;
            }
        })

        if (!output) {
            logger('will be saved')
            onTrigger()
        }

    }

    const onTrigger = React.useCallback((values) => {
        const msg = {
            DayOf: day,
            WeekOf: moment(day).add(-1, 'days').day("Monday").format('YYYY-MM-DD'),
            Hours: Hours,
            ID: data.ID,
            propList: taskFields
        };

        handleCopyCallback(msg);
        handleClose();
    })

    const handleDate = (Data) => {
        if (moment().weekday(0).isSameOrBefore(Data.target.value, 'day')) {
            setDay(Data.target.value);
            logger(Data.target.value);
        } else {
            setAlertText("You cannot copy to dates in the previous week from today")
            setAlert(true)
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {

    })

    return (
        <div>
            <Tooltip title="Copy Entry" placement="top-end">
            <IconButton variant="contained" onClick={handleClickOpen}>
                <LibraryAddRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Copy Day
                                        </Typography>
                                        <Button autoFocus color="inherit" onClick={() => {
											var mins = Hours.toString().substring(Hours.toString().indexOf(".")+1);
											if (mins !== null && mins !== "" && Hours.indexOf(".")!==-1 && (mins.length === 1 ? parseInt(mins + "0") : parseInt(mins)) % 25 !== 0) {
												setAlertText(`Please add time by the quarter hour(" .25 , .5 , .75 ")`);
				                                setAlert(true);
				                                return;
											}
                                            if (Hours != 0) {
                                                CheckBilled(day)
                                                    .then(response => Check(response))
                                            } else {
                                                setAlertText(`you need to add time`)
                                                setAlert(true)
                                            }
                                        }}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <div>
                                    {logger(taskFields)}
                                    <p><b>Task:</b> {data.Task}</p>
                                    {taskFields.map((item) => (<p>{item.label}: {item.IsDropdown ? item.Name : item.Data} </p>))}
                                    <p><b>Role:</b> {data.Role}</p>
                                </div>
                                <DialogTitle>Copy To:</DialogTitle>
                                <FormControl style={{ minWidth: 240 }}>
                                    <TextField
                                        name='date'
                                        id="outlined-Date"
                                        type="date"
                                        onChange={handleDate}
                                        value={day}
                                        label="Date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </FormControl>
                                <FormControl style={{ minWidth: 100 }}>
                                    <TextField
                                        label="Hours"
                                        sx={{ m: 1 }}
                                        id="outlined-number"
                                        value={Hours}
                                        type="number"
                                        InputProps={{
                                            inputProps: {
                                                max: 24,
                                                min: 0,
                                                style: {
                                                    textAlign: "center",
                                                    minWidth: 120,
                                                    height: 28,
                                                    marginTop: 9,
                                                    paddingTop: 0,
                                                    paddingLeft: 4,

                                                }
                                            }
                                        }}
                                        onChange={e => {
                                            if (separatorList["period"].regex.test(e.target.value)) {
                                                setHours(e.target.value);
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="L&P Lock"
                    aria-describedby="Time Period locked for this work"
                >
                    <DialogTitle id="Time Entry">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {AlertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </div>
    );
}